import { addDays } from "@fullcalendar/core/internal";
import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import {
  LIST_COMMENTAIRE,
  UPDATE_BRIN,
  UPDATE_RACCORDEMENT,
} from "../../Utils/constant";
import { add, updateOne } from "../../services/service";
import { usePortStore } from "../../store/pboStore/listPort";
import { useStoreApp } from "../../store/storeApp";
import { SubmitButton } from "../Widget/SubmitButton";
import { ValidateMessage } from "../Widget/ValidateMessage";

export const ValidationRaccordement = ({ numeroTicket, handleNext }) => {
  const { pboId, brin, id } = useParams();
  const [dateStart, setStartDate] = useState(new Date());
  const [dateEnd, setEndDate] = useState(addDays(dateStart, 1));
  const [selectBrin, setSelectBrin] = useState(null);
  const [confirm, setConfirm] = useState(null);
  const [isSubmit, setIsSubmit] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [resultat, setResultat] = useState(null);
  const submit = (data) => {
    setIsSubmit(true);
    const requestData = {
      ...data,
      dateHDebut: dateStart.toISOString().slice(0, -1),
      dateHFin: dateEnd.toISOString().slice(0, -1),
      status: "REALISER",
      numeroTicket: numeroTicket,
    };
    if (confirm === "OUI") {
      add(`${UPDATE_BRIN}/${selectBrin}`, "application/json", {
        numeroTicket: id,
      })
        .then(() => {})
        .catch(() => {});
    }

    updateOne(UPDATE_RACCORDEMENT, "", requestData)
      .then((res) => {
        if (res.status === 200) {
          setIsSubmit(null);
          toast.success("Raccordement éffectuée");
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        toast.error(err?.response?.data?.donnee);
      });
  };
  const commentaire = useStoreApp();
  const listBrin = usePortStore();
  useEffect(() => {
    commentaire.getData(LIST_COMMENTAIRE, { page: 0, param: "", size: 10 }, "");
    listBrin.getData(`/${pboId}?page=0&size=8&status=LIBRE`);
  }, []);
  return (
    <>
      {isSubmit !== null ? (
        <form
          onSubmit={handleSubmit(submit)}
          className="shadow-sm border rounded w-full p-8"
        >
          <h1 class="text-amber-500 font-mtn text-2xl font-semibold tracking-tight">
            Realisation du raccordement
          </h1>
          <div className="my-4 space-y-4">
            <div className="my-2">
              <label className="form-control  w-full">
                <div className="label -mb-1">
                  <span className="label-text font-medium text-gray-400">
                    Date et heure de debut{" "}
                    <span className="text-red-500">*</span>
                  </span>
                </div>

                <ReactDatePicker
                  selected={dateStart}
                  locale="pt-BR"
                  timeIntervals={15}
                  dateFormat="dd-MM-yyyy hh:mm:ss"
                  minDate={new Date()}
                  showTimeSelect
                  timeFormat="p"
                  className=" px-2 flex items-center justify-center border-[1px] w-full h-8 rounded-lg"
                  onChange={(date) => {
                    setStartDate(date);
                    console.log(date);
                  }}
                />
              </label>

              <label className="form-control  w-full">
                <div className="label -mb-1">
                  <span className="label-text font-medium text-gray-400">
                    Date et heure de fin <span className="text-red-500">*</span>
                  </span>
                </div>

                <ReactDatePicker
                  selected={dateEnd}
                  locale="pt-BR"
                  timeIntervals={15}
                  dateFormat="dd-MM-yyyy hh:mm:ss"
                  minDate={new Date()}
                  showTimeSelect
                  timeFormat="p"
                  className=" px-2 flex items-center justify-center border-[1px] w-full h-8 rounded-lg"
                  onChange={(date) => {
                    setEndDate(date);
                    console.log(date);
                  }}
                />
              </label>
            </div>

            <div className="my-2">
              <label className="form-control w-full">
                <div className="label">
                  <span className="label-text text-sm font-semibold">
                    Resultat du raccordement{" "}
                    <span className="text-red-500">*</span>
                  </span>
                </div>
                <select
                  {...register("resultat", { required: true })}
                  className="select select-bordered w-full"
                  onChange={(e) => {
                    setResultat(e.target.value);
                  }}
                >
                  <option value={""} disabled selected>
                    Selectionnez un status
                  </option>
                  <option value={"OK"}>OK</option>
                  <option value={"NON_OK"}>Non OK</option>
                  <option value={"PARTIALY_OK"}>Partialy OK</option>
                </select>
              </label>
            </div>

            <label className="form-control w-full">
              <div className="label -mb-1">
                <span className="label-text font-medium text-gray-400">
                  Type commentaire <span className="text-red-500">*</span>
                </span>
              </div>
              <select
                {...register("typeCommentaire", { required: true })}
                className="select select-bordered w-full h-10"
              >
                <option value={""} disabled selected>
                  Selectionnez un type
                </option>
                {commentaire?.data?.data?.map((item) => (
                  <option value={item.id}>{item.designation}</option>
                ))}
              </select>
            </label>

            <div className="my-2">
              <label htmlFor="" className="text-sm font-medium">
                Commentaire
              </label>
              <textarea
                {...register("commentaire")}
                placeholder="Votre commentaire"
                className="textarea textarea-bordered textarea-sm w-full"
              ></textarea>
            </div>

            {/* <div className='my-2'>
                            <label className="form-control w-full">
                                <div className="label">
                                    <span className="label-text text-sm font-semibold">Voulez-vous modifier le brin ?</span>
                                </div>
                                <select className="select select-bordered w-full" onChange={(e) => {
                                    setConfirm(e.target.value)
                                }}>
                                    <option value={''} disabled selected>Selectionnez un status</option>
                                    <option value={'OUI'}>OUI</option>
                                    <option value={'NON'}>NON</option>
                                </select>
                            </label>
                        </div>
                        {
                            confirm === 'OUI' ?
                                <div>
                                    <label className="text-sm">Liste des brins disponible <span className="text-red-500">*</span></label>
                                    <select
                                        onChange={(e) => setSelectBrin(e.target.value)}
                                        className="select pl-non w-full"
                                    >
                                        <option selected value="">Liste des brins</option>
                                        {
                                            listBrin?.data?.data?.map((item) => (
                                                <option value={item?.id}>
                                                    {item?.designation}
                                                </option>
                                            ))
                                        }

                                    </select>
                                </div>

                                : null
                        } */}
          </div>
          <SubmitButton isSubmit={isSubmit} label={"Valider"} />
        </form>
      ) : (
        <ValidateMessage texte={"Raccordement éffectué"} />
      )}
      <div className="w-full mt-4">
        <hr />
        <div
          className="flex mt-4"
          sx={{ display: "flex", flexDirection: "row", pt: 2 }}
        >
          <Box sx={{ flex: "1 1 auto" }} />
          {(isSubmit === null && resultat === "NON_OK") ||
          resultat === "NON_OK" ? (
            <button
              disabled={isSubmit !== null ? true : false}
              className={`bg-[#ffcb05] btn btn-sm py-1 px-2 font-medium rounded-lg `}
              onClick={() => {
                window.history.back();
                localStorage.removeItem("numeroTicket");
              }}
            >
              Terminer
            </button>
          ) : (
            <button
              disabled={isSubmit !== null ? true : false}
              className={`bg-[#ffcb05] btn btn-sm py-1 px-2 font-medium rounded-lg `}
              onClick={handleNext}
            >
              Poursuivre
            </button>
          )}
        </div>
      </div>
    </>
  );
};
